import { GridLegacy as Grid, MenuItem, SelectChangeEvent } from '@mui/material';
import SelectNoBorder from './SelectNoBorder';
import { Typography, colors } from '@sweep-io/sweep-design';

const CHEVRON_SIZE = {
  small: '12px',
  regular: '16px',
};

export interface SortOption {
  label: string;
  value: string;
}

interface SortWidgetProps {
  value: string;
  onChange: (value: string) => void;
  options: SortOption[];
  size?: 'small' | 'regular';
}

export const SortWidget = ({ value, onChange, options, size = 'regular' }: SortWidgetProps) => {
  const isSmall = size === 'small';

  const handleChange = (e: SelectChangeEvent<unknown>) => {
    onChange(e.target.value as string);
  };

  return (
    <Grid container width="auto" alignItems="center" flexWrap="nowrap" data-testid="sort-widget">
      <Typography variant={isSmall ? 'caption' : 'body'} color={colors.grey[700]}>
        Sort:
      </Typography>
      <Grid container justifyContent="flex-end">
        <SelectNoBorder
          value={value}
          onChange={handleChange}
          sx={{
            backgroundColor: 'transparent',
            minHeight: 'unset',
            '& .MuiSelect-select': {
              backgroundColor: 'transparent',
            },
            '& .MuiSelect-select.MuiOutlinedInput-input.MuiInputBase-input': {
              display: 'flex',
              alignContent: 'center',
              flexWrap: 'wrap',
              padding: '4px',
              paddingRight: `calc(${CHEVRON_SIZE[size]} + 4px)`,
              '.MuiTypography-root': {
                fontSize: isSmall ? '12px' : '14px',
              },
            },
            '.MuiSelect-icon': {
              top: isSmall ? '10px' : 'unset',
              width: CHEVRON_SIZE[size],
              height: CHEVRON_SIZE[size],
              right: 0,
            },
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            sx: {
              '.MuiMenu-paper': {
                width: '160px',
              },
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Typography variant="body" color={colors.grey[900]}>
                {option.label}
              </Typography>
            </MenuItem>
          ))}
        </SelectNoBorder>
      </Grid>
    </Grid>
  );
};
